import { Navigate, Route, Routes } from "react-router-dom";
import { AppRoutesUI } from "../config/appRoutes";
import { RedirectUnauthorized } from "../utils/authRedirectHandlers";
import { TopNav } from "../components/generic/topNav.component";
import { SideNav } from "../components/generic/sideNav.component";
import { SuperAdminAddPage } from "../pages/superAdmin";
import { SuperAdminList } from "../pages/superAdmin";
import { BlackListEmailAddPage } from "../pages/blackListEmail";
import { BlackListEmailListPage } from "../pages/blackListEmail";
import { AdminsAddPage } from "../pages/admins";
import { AdminsListPage } from "../pages/admins";
import { UsersAddPage } from "../pages/users";
import { UsersListPage } from "../pages/users";
import { UserLogList } from "../pages/userLog";
import { SuperAdminEditPage } from "../pages/superAdmin/superAdminEditPage";
import { AdminEditPage } from "../pages/admins/adminsEditPage";
import { UsersEditPage } from "../pages/users/usersEditPage";
import { BlackListEmailEditPage } from "../pages/blackListEmail";
import { SuperAdminProfilePage } from "../pages/superAdmin/superAdminProfilePage";
import { SuperAdminChangePasswordPage } from "../pages/superAdmin/superAdminChangePasswordPage";
import { UsersProfilePage } from "../pages/users/usersProfilePage";
import { AdminProfilePage } from "../pages/admins/adminProfilePage";
import { AdminChangePasswordPage } from "../pages/admins/adminChangePasswordPage";
import { useAppSelector } from "../core/redux/reduxStore";
import { AddUserEmailModal } from "../components/modal/addUserEmailModal";

export const PrivateLayout = () => {
  const { role } = useAppSelector((state) => state.auth);

  return (
    <RedirectUnauthorized>
      <TopNav />
      <div className="site-content d-flex">
        <SideNav />
        <div className="container-fluid p-0">
          <div className="row gx-0">
            <main className="site-main-content">
              <Routes>
                {role?.toLowerCase() === "superadmin" ? (
                  <Route path={AppRoutesUI.Root} element={<SuperAdminList />} />
                ) : role?.toLowerCase() === "admin" ? (
                  <Route path={AppRoutesUI.Root} element={<AdminsListPage />} />
                ) : (
                  <Route
                    path={AppRoutesUI.Root}
                    element={<UsersProfilePage />}
                  />
                )}
                <Route
                  path={AppRoutesUI.SuperAdmin.SuperAdminList()}
                  element={<SuperAdminList />}
                />
                <Route
                  path={AppRoutesUI.SuperAdmin.SuperAdminCreate()}
                  element={<SuperAdminAddPage />}
                />
                <Route
                  path={AppRoutesUI.BlackListEmail.EmailList()}
                  element={<BlackListEmailListPage />}
                />
                <Route
                  path={AppRoutesUI.BlackListEmail.EmailAdd()}
                  element={<BlackListEmailAddPage />}
                />
                <Route
                  path={AppRoutesUI.Admins.AdminList()}
                  element={<AdminsListPage />}
                />
                <Route
                  path={AppRoutesUI.Admins.AdminAdd()}
                  element={<AdminsAddPage />}
                />
                <Route
                  path={AppRoutesUI.Users.UsersList()}
                  element={<UsersListPage />}
                />
                <Route
                  path={AppRoutesUI.Users.UsersAdd()}
                  element={<UsersAddPage />}
                />
                <Route
                  path={AppRoutesUI.UserLog.Root()}
                  element={<UserLogList />}
                />
                <Route
                  path={AppRoutesUI.SuperAdmin.SuperAdminEdit()}
                  element={<SuperAdminEditPage />}
                />
                <Route
                  path={AppRoutesUI.SuperAdmin.SuperAdminProfileEdit()}
                  element={<SuperAdminEditPage />}
                />
                <Route
                  path={AppRoutesUI.Admins.AdminEdit()}
                  element={<AdminEditPage />}
                />
                <Route
                  path={AppRoutesUI.Admins.AdminProfileEdit()}
                  element={<AdminEditPage />}
                />
                <Route
                  path={AppRoutesUI.Users.UsersEdit()}
                  element={<UsersEditPage />}
                />
                <Route
                  path={AppRoutesUI.Users.UsersProfileEdit()}
                  element={<UsersEditPage />}
                />
                <Route
                  path={AppRoutesUI.BlackListEmail.EmailEdit()}
                  element={<BlackListEmailEditPage />}
                />
                {role?.toLowerCase() === "superadmin" ? (
                  <Route
                    path={AppRoutesUI.SuperAdmin.SuperAdminProfile()}
                    element={<SuperAdminProfilePage />}
                  />
                ) : role?.toLowerCase() === "admin" ? (
                  <Route
                    path={AppRoutesUI.Admins.AdminProfileView()}
                    element={<AdminProfilePage />}
                  />
                ) : (
                  <Route
                    path={AppRoutesUI.Users.UsersProfileView()}
                    element={<UsersProfilePage />}
                  />
                )}
                <Route
                  path={AppRoutesUI.SuperAdmin.SuperAdminChangePassword()}
                  element={<SuperAdminChangePasswordPage />}
                />
                <Route
                  path={AppRoutesUI.Admins.AdminChangePassword()}
                  element={<AdminChangePasswordPage />}
                />
                <Route
                  path="/*"
                  element={
                    <Navigate to={AppRoutesUI.NotFound.Path()} replace />
                  }
                />
              </Routes>
            </main>
          </div>
        </div>
      </div>
      <AddUserEmailModal />
    </RedirectUnauthorized>
  );
};
